import React from 'react';
import { motion } from 'framer-motion';
import { Calculator } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center pt-40 lg:pt-48 overflow-hidden">
      {/* Imagem de Fundo com Opacidade - Página Inteira */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_site-generator-134/artifacts/h4tn326t_image.png)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center 30%',
          opacity: 0.7,
          top: '120px'
        }}
      />
      
      {/* Overlay de cor creme */}
      <div className="absolute inset-0 bg-[#F2F0E9]/50" />

      <div className="relative z-10 max-w-7xl mx-auto pl-6 md:pl-8 lg:pl-12 pr-6 md:pr-12 lg:pr-24 w-full">
        <div className="max-w-2xl">
          {/* Conteúdo */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 lg:space-y-8"
          >
            <div className="space-y-4">
              <p className="text-sm text-gray-500 tracking-wide" data-testid="hero-crm">
                CRN 36313
              </p>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-gray-600" data-testid="hero-profession">
                Nutricionista
              </h2>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green leading-tight" data-testid="hero-name">
                Thiago Ferreira
              </h1>
              
              <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-700 leading-relaxed pt-4" data-testid="hero-tagline">
                CUIDANDO DE VOCÊ DE DENTRO PARA FORA
              </h3>
              
              <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl pt-2" data-testid="hero-subtitle">
                A alimentação vai muito além de dietas prontas. Aqui, cada plano nutricional é desenvolvido de forma individualizada, respeitando sua rotina, suas preferências e seus objetivos.
              </p>
            </div>

            <button
              onClick={scrollToContact}
              data-testid="hero-cta-button"
              className="bg-brand-green text-white px-8 py-4 rounded-full font-medium text-base shadow-lg hover:shadow-xl hover:bg-[#0d6a0c] transition-all inline-block animate-pulse-slow"
            >
              Agende sua Consulta ›
            </button>
          </motion.div>
        </div>
      </div>

      {/* Botão Calculadora IMC - Canto Superior Direito */}
      <a
        href="#calculadoras"
        data-testid="hero-imc-button"
        className="absolute top-36 lg:top-40 right-6 md:right-12 z-20 group flex items-center"
      >
        <div className="flex items-center bg-brand-green rounded-full shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
          <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
            <Calculator className="w-6 h-6 text-white" />
          </div>
          <span className="max-w-0 group-hover:max-w-[200px] overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out text-white font-semibold text-sm pr-0 group-hover:pr-5">
            Calcule seu IMC
          </span>
        </div>
      </a>

      {/* Botão Flutuante - Canto Inferior Direito */}
      <a
        href="https://wa.me/5535988366028?text=Ol%C3%A1%20Thiago%2C%20tudo%20bem%3F%20Vim%20pelo%20seu%20site%20e%20gostaria%20de%20agendar%20uma%20consulta.%20Poderia%20me%20informar%20sobre%20os%20hor%C3%A1rios%20dispon%C3%ADveis%20e%20os%20planos%20de%20acompanhamento%3F%20Desde%20j%C3%A1%2C%20agrade%C3%A7o!"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hero-floating-cta"
        className="fixed bottom-4 right-4 bg-brand-green text-white px-8 py-4 rounded-full font-semibold text-base shadow-2xl hover:shadow-3xl hover:bg-[#0d6a0c] transition-all flex items-center gap-2 animate-pulse-slow no-underline"
        style={{ zIndex: 10000 }}
      >
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        Agende sua Consulta
      </a>
    </section>
  );
};

export default Hero;